module.exports = __webpack_public_path__ + "img/ico1.301ac10f.png";